<template>
    <AModal
        :visible="visible"
        title="Details"
        width="90%"
        @cancel="handleModalCancel"
        :footer="null">
        <MdTable
            :columns="state.columns"
            :data-source="state.data"
            size="small"
            :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)">

            <template #file="{ record }">
                <ASpace>
                    <ATooltip
                        v-if="record.image"
                        title="Lihat PDF">
                        <AButton
                            class="button"
                            size="small"
                            :href="record.image"
                            target="blank">
                            <template #icon><FilePdfOutlined /></template>
                        </AButton>
                    </ATooltip>
                </ASpace>
            </template>
        </MdTable>
    </AModal>
</template>

<script>
import { defineComponent, reactive, onMounted, ref } from 'vue'
import { FilePdfOutlined } from '@ant-design/icons-vue'

export default defineComponent({
    components: {
        FilePdfOutlined,
    },
    props: {
        visible: [Boolean],
        items: {
            type: [Array],
            default: () => [],
        },
    },
    emits: ['update:visible'],
    setup(props, { emit }) {
        const state = reactive({
            data: [],
            columns: [
                {
                    title: 'Tanggal',
                    dataIndex: 'date',
                },
                {
                    title: 'Kode Toko',
                    dataIndex: 'customer_code',
                },
                {
                    title: 'Nama Toko',
                    dataIndex: 'customer_name',
                },
                {
                    title: 'Pengguna',
                    dataIndex: 'username',
                },
                {
                    title: 'Kategori',
                    dataIndex: 'header',
                },
                {
                    title: 'Catatan',
                    dataIndex: 'rejection_note',
                },
                {
                    title: 'Lampiran',
                    slots: { customRender: 'file' },
                },
                {
                    title: 'Status Approval',
                    dataIndex: 'status_approval',
                },
            ],
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:items', [])
        }

        // handle vue
        onMounted(() => {
            state.data = props.items
        })

        return {
            handleModalCancel,
            state,
        }
    },
})
</script>